import { render, staticRenderFns } from "./ComplaintEditForUser.vue?vue&type=template&id=058c3785"
import script from "./ComplaintEditForUser.vue?vue&type=script&lang=js"
export * from "./ComplaintEditForUser.vue?vue&type=script&lang=js"
import style0 from "./ComplaintEditForUser.vue?vue&type=style&index=0&id=058c3785&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports